import React from "react";
import "./Modal.css";

interface ModalProps {
    isOpen: boolean;
    title: string;
    message: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, title, message }) => {
    if (!isOpen) return null;

    return (
        <div>
            <div className="session-expired-modal mt-2">
                <h2 className="modal-title">{title}</h2>
                <p className="modal-message">{message}</p>
            </div>
        </div>
    );
};

export default Modal;
